import { render } from "./BarcodeItems.vue?vue&type=template&id=97fe228a&scoped=true"
import script from "./BarcodeItems.vue?vue&type=script&lang=js"
export * from "./BarcodeItems.vue?vue&type=script&lang=js"

import "./BarcodeItems.vue?vue&type=style&index=0&id=97fe228a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97fe228a"]])

export default __exports__